import React from "react";

export default function AccountBalanceCardSkeleton() {
  return (
    <article className="new-balance-card new-balance-card--skeleton" aria-hidden="true">
      <div className="new-balance-card__header">
        <span className="new-balance-card__icon new-balance-card__icon--skeleton" />
        <div className="new-balance-card__titles">
          <span className="new-balance-card__skeleton-line new-balance-card__skeleton-line--account" />
          <span className="new-balance-card__skeleton-line new-balance-card__skeleton-line--currency" />
          <span className="new-balance-card__skeleton-line new-balance-card__skeleton-line--subtitle" />
        </div>
        <div className="new-balance-card__badge-wrap">
          <span className="new-balance-card__skeleton-pill" />
        </div>
      </div>

      <div className="new-balance-card__balance">
        <span className="new-balance-card__skeleton-line new-balance-card__skeleton-line--amount" />
        <span className="new-balance-card__skeleton-line new-balance-card__skeleton-line--amount-suffix" />
      </div>

      <div className="new-balance-card__trend">
        <span className="new-balance-card__skeleton-pill new-balance-card__skeleton-pill--trend" />
      </div>

      <div className="new-balance-card__stats">
        {[0, 1, 2].map((item) => (
          <div key={item}>
            <span className="new-balance-card__skeleton-line new-balance-card__skeleton-line--stat-label" />
            <span className="new-balance-card__skeleton-line new-balance-card__skeleton-line--stat-value" />
          </div>
        ))}
      </div>
    </article>
  );
}
